export default "__VITE_ASSET__BFNnrh1N__"